import React from 'react';
import Image from 'next/image';
import { Box, Text, Flex, Heading } from '@terminal/design-system';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import NextLink from 'next/link';
import { ActionCardStoryblok, Storyblok } from '../types';
import { StoryblokComponent } from '@storyblok/react';

export function ActionCard({ blok, page }: Storyblok<ActionCardStoryblok>) {
  console.log(blok);
  return (
    <NextLink {...(blok.link || {})} href={blok.link?.url}>
      <Box
        borderRadius="md"
        border="1px solid"
        borderColor="ui.secondary"
        _hover={{ cursor: 'pointer', boxShadow: 'lg' }}
      >
        <Flex align="center" justify="space-between" px={6} py={4}>
          <Box display="flex" gap={2} alignItems="center">
            {blok.headingIcon?.filename && (
              <Image
                src={blok.headingIcon?.filename}
                alt={blok.headingIcon.alt}
                width="50"
                height="50"
              />
            )}
            <Heading as="h4" variant="heading-2">
              {blok.heading}
            </Heading>
          </Box>
          <ArrowForwardIcon color="accent.main" w={6} h={6} />
        </Flex>
        <Box bgColor="bg.secondary" py={6} px={8}>
          <Text fontSize="lg" fontWeight="bold" mb={4}>
            {blok.title}
          </Text>
          {blok.items?.map((listBlok) => {
            return <StoryblokComponent blok={listBlok} key={listBlok._uid} page={page} />;
          })}
        </Box>
        <Text
          fontWeight="bold"
          textAlign="center"
          py={7}
          px={4}
          bgColor={blok.footerColor?.value}
          color="text.inverse"
          borderBottomRadius="md"
        >
          {blok.footer}
        </Text>
      </Box>
    </NextLink>
  );
}
